import React from 'react';
import { Typography } from '@mui/material';
import { User } from '@/types/user';
import UsersTable from '@/features/settings/components/UsersTable';

interface OrganizationMembersSectionProps {
  users: User[];
  onEditUser: (user: User) => void;
  onDeleteUser: (userId: number) => void;
  onDisableUser: (userId: number) => void;
}

export const OrganizationMembersSection: React.FC<OrganizationMembersSectionProps> = ({
  users,
  onEditUser,
  onDeleteUser,
  onDisableUser,
}) => {
  if (!users.length) return null;

  return (
    <>
      {/* Margins rather than a wrapper's padding: padding indented the heading
          away from the table's left edge, and the section needs more room above
          it than below so the heading groups with its own table. */}
      <Typography variant="subtitle1" sx={{ mt: 5, mb: 3 }}>
        Organization Members
      </Typography>
      <UsersTable
        invitees={false}
        users={users}
        handleEditUserGroup={onEditUser}
        handleDelete={onDeleteUser}
        handleDisable={onDisableUser}
      />
    </>
  );
};
